module.exports = __webpack_public_path__ + "static/media/soehne-web-halbfett.388ac658.woff2";